module.exports = __webpack_public_path__ + "img/img12.ef77b413.png";